// extracted by mini-css-extract-plugin
export var footer = "style-module--footer--40524";
export var ftn = "style-module--ftn--58d3c";
export var instagram = "style-module--instagram--b2abc";
export var language = "style-module--language--bf9fa";
export var link = "style-module--link--3f35f";
export var links = "style-module--links--94249";
export var logo = "style-module--logo--e8290";
export var rights = "style-module--rights--67454";
export var subLink = "style-module--subLink--b7093";
export var subLinks = "style-module--subLinks--fd993";